if(!customElements.get('wholesale-form')) {
  class ComponentWholesaleForm extends HTMLElement {
    constructor() {
      super();
      this.useKlaviyo = this.dataset.useKlaviyo=='true';
      this.querySelector('form').addEventListener('submit', this.contactFormSubmitHandler.bind(this));

      this.countriesInput = this.querySelector('#input_contry');
      this.countriesInput.value = this.countriesInput.dataset.default;

      this.statesInput = this.querySelector('#input_state');

      this.countriesInput.addEventListener('change', () => {this.loadProvinces()});
      this.loadProvinces();
    }

    loadProvinces(){
      if (!Countries[this.countriesInput.value]) {
        return;
      }

      var provinces = Countries[this.countriesInput.value].provinces;
      if (provinces) {
        this.statesInput.options.length = 0;
        for (var i=0; i<provinces.length; i++) {
          this.statesInput.options.add(new Option(provinces[i], provinces[i]));
        }
        this.statesInput.parentElement.style.display = 'block';
      } else {
        this.statesInput.parentElement.style.display = 'none';
      }
    }

    contactFormSubmitHandler(e) {
      var self = this;
      var form = self.querySelector('form');
      var error = false;
      var errorMsg = form.querySelector('.error-msg');
      var msg = '';
      var requiredFields = [];

      errorMsg.style.display = 'none';
      form.querySelectorAll('.error').forEach((elem)=>{
        elem.classList.remove('error');
      });
      form.querySelectorAll('.required').forEach((elem)=>{
        if(elem.value=="" || (elem.type=='radio' && !form.querySelector('input[name="'+elem.name+'"]:checked')) || (elem.type=='checkbox' && !elem.checked) ) {
          error = true;
          elem.classList.add('error');
          if (elem.ariaLabel) {
            requiredFields.push(elem.ariaLabel);
          } else if (elem.placeholder) {
            requiredFields.push(elem.placeholder);
          } else if (elem.labels && elem.labels.length > 0) {
            requiredFields.push(elem.labels[0].innerText);
          }
        }
      });
      if (requiredFields.length==1) {
        msg = lngg.general__forms__complete_the_field_message.replace(new RegExp(/{{ *field *}}/), requiredFields[0]);
      }
      if(error) {
        errorMsg.innerHTML = msg || lngg.general__forms__complete_all_the_fields_message;
        errorMsg.style.display = 'block';
      } else {
        if(!$s.validateEmail(form.querySelector('.email').value)) {
          error = true;
          form.querySelector('.email').classList.add('error');
          errorMsg.style.display = 'block';
          errorMsg.innerHTML = lngg.general__forms__enter_a_valid_email_message;
        }
      }
      if(!error) {
        var onsubmit = form.getAttribute('onsubmit');
        if (onsubmit && onsubmit.indexOf('recaptcha')>-1) {
          self.dispatchEvent(new CustomEvent('submitSuccess'));
          return true;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        var params = {
          data: new FormData(form),
          success: function(data, response){
            if(response.url.includes('/challenge')) {
              form.removeEventListener('submit', self.contactFormSubmitHandler);
              form.submit();
            } else {
              form.querySelector('.form-wrap').style.display = 'none';
              form.querySelector('.success-msg').style.display = 'block';
              self.dispatchEvent(new CustomEvent('submitSuccess'));
            }
          },
          error: function(){
            form.removeEventListener('submit', self.contactFormSubmitHandler);
            form.submit();
          }
        }
        if (self.useKlaviyo) {
          params['url'] = form.dataset.ajaxSubmit;
        } else {
          params['url'] = form.getAttribute('action');
          params['type'] = 'text';
        }
        console.log(params);
        $s.post(params);
      } else {
        e.preventDefault();
        e.stopImmediatePropagation();
        
      }
    }

    

  }
  customElements.define('wholesale-form', ComponentWholesaleForm);
}